import RoutePath from 'shared/utils/namedUrls';

const basePath = '/settings/';

export default {
  changePassword: new RoutePath(`${basePath}change-password/`),
};
